import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'catalog-municipalities',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'catalog-municipalities-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                                        {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.catalog-municipalities-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "catalog-municipalities-index" */ '@/modules/configurations/catalogs/catalog-municipalities/views/Index.vue')
        }
    ]
}
